.dock { display: flex; flex-direction: column; gap: 10px; box-sizing: border-box; padding: 16px 14px; overflow-y: auto; scrollbar-width: thin; border-radius: 16px; background: var(--card); box-shadow: var(--sh); }
.head { display: flex; align-items: center; gap: 8px; }
.tabs { flex-grow: 1; display: flex; padding: 3px; border-radius: 11px; background: var(--ctl); }
.tab { flex: 1 1 0; height: 30px; border: 0; border-radius: 8px; background: transparent; color: var(--tx2); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.tab span { color: var(--lb); }
.tab.on { background: var(--ctl-on); color: var(--tx); box-shadow: var(--seg-sh); }
.close { width: 30px; height: 30px; border: 0; border-radius: 8px; background: transparent; color: var(--lb); font: inherit; font-size: 17px; cursor: pointer; }
.tab:focus-visible, .close:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
@media (hover: hover) { .close:hover { background: var(--ctl); } }
.task { display: flex; gap: 10px; padding: 10px; border-radius: 12px; background: var(--sub); }
.task input { flex-shrink: 0; width: 16px; height: 16px; margin: 2px 0 0; accent-color: var(--pri); }
.tk { font-weight: 500; }
.meta { margin-top: 3px; font-size: 12px; color: var(--lb); }
.meta b { font-weight: var(--fw-label); color: var(--link); }
.late { color: var(--err); }
.noti { display: flex; gap: 10px; padding: 10px 4px; border-top: 1px solid var(--line); }
.dot { flex-shrink: 0; width: 8px; height: 8px; margin-top: 6px; border-radius: 50%; }
.dot[data-tone='mid'] { background: var(--d-blue); }
.dot[data-tone='done'] { background: var(--ok-dot); }
.dot[data-tone='err'] { background: var(--err-bd); }
.when { margin-top: 2px; font-size: 12px; color: var(--lb); }
